import { render, staticRenderFns } from "./site-area-cascader.vue?vue&type=template&id=4e923b08&"
import script from "./site-area-cascader.vue?vue&type=script&lang=js&"
export * from "./site-area-cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports